<template>
  <div>
    <booking-menu-with-budget-header :title="$t('booking.other.title')" />

    <v-card-title>
      <v-row>
        <v-col md="3" sm="5" cols="12">
          <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="bookings"
      :search="search"
      :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
      :sort-desc.sync="pagination.descending"
      :sort-by.sync="pagination.sortBy"
    >
      <template #item="{item}">
        <tr>
          <td class="">{{ formatDateView(item.creation_date) }}</td>
          <td>
            {{ item.name }}
            <v-chip label outlined small style="color: #FFE3F3; background-color: #ff99d0 !important;" v-if="item.is_cancelled === 1"
              >{{ $t("booking.canceled") }}
            </v-chip>
            <assigned-delegations-chip :delegations="item.delegations" />
          </td>
          <td style="text-transform: capitalize">{{ item.passengers_names }}</td>
          <td>{{ item.reservation_number }} {{ item.ticket_number }}</td>
          <td class="datatable-total-amount">
            <template v-if="item.invoice_gross_value !== null">{{ item.invoice_gross_value }} {{ item.invoice_currency }}</template>
            <template v-else-if="item.total_amount !== null">{{ item.total_amount }} PLN</template>
          </td>
          <td>
            <v-tooltip bottom>
              {{ $t("global.goToDetails") }}
              <template v-slot:activator="{ on }">
                <v-btn :to="'/booking/other/detail/' + item.id" class="mx-0" icon v-on="on">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.downloadFile") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadAttachment(item.id)" class="mx-0" icon v-on="on">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import formatDateView from "../../repository/fotmatDateView";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import AssignedDelegationsChip from "../../components/Booking/AssignedDelegationsChip";
import downloadFile from "../../repository/downloadFile";
import BookingMenuWithBudgetHeader from "../../components/Booking/BookingMenuWithBudgetHeader";

export default {
  name: "BookingOtherView",
  components: { BookingMenuWithBudgetHeader, AssignedDelegationsChip },
  data: () => ({
    search: "",
    bookings: [],
    pagination: {
      sortBy: "creation_date",
      descending: true
    }
  }),
  computed: {
    invoices: function() {
      return this.$store.getters["Booking/bookingList"];
    },
    headers() {
      return [
        { text: this.$t("booking.dateShort"), value: "creation_date" },
        { text: this.$t("booking.other.serviceName"), value: "name" },
        {
          text: this.$t("booking.passengers"),
          value: "passengers_names",
          sortable: false
        },
        { text: this.$t("booking.numberShort"), value: "reservation_number" },
        { text: this.$t("booking.price"), value: "total_amount" },
        { text: "", value: "actions", sortable: false }
      ];
    }
  },
  methods: {
    viewBooking: function(booking) {
      this.$store.dispatch("Booking/loadBookingDetails", booking);
    },
    formatDateView: formatDateView,
    filterOverAllProperty: filterOverAllProperty,
    downloadAttachment(id) {
      downloadFile("booking/get-booking-file?bookingId=" + id);
    }
  },
  created() {
    this.axios.get("booking/get-other").then(resp => {
      this.bookings = resp.data;
    });
  }
};
</script>

<style scoped />
